// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"04825a40","977":"a555c445"}[chunkId] + ".chunk.js";
};